export interface Video {
  id: string
  name: string
  reference_id?: string
  description: string
  custom_fields: CustomFields
  text_tracks: any[]
  duration: number
  seriesTitle: string
  sources: Source[]
  poster?: string
}

export interface Source {
  [src: string]: string,
  type: string,
  key_systems: any
}

export interface CustomFields {
  seriestitle?: string
  title?: string
  seriesdesce?: string
  seriesdescg?: string
  longdescgaeilge?: string
  layout?: string
  episode?: string
  series?: string
  category_c?: string
  prepost?: string

  p_prodcode?: string
  s_prodcode?: string
  date?: string
  geo_restrict?: string
  parental_guide?: string

}

export interface PlayerAPIVideoResponse {
  brightcoveVideo?: Video
}

export interface CMSVideo {
  providerId: string
}
export function formattedTitleForVideo(video: Video): string {
  
  let titleVal: string | undefined = undefined
  if (video.custom_fields.seriestitle) {
      if (video.custom_fields.seriestitle){
          titleVal = video.custom_fields.seriestitle?.slice(0, 90)
      }
  }
  
  let seriesAndEpisodeNum: string | undefined = undefined
  if (video.custom_fields.series && video.custom_fields.episode) {
    seriesAndEpisodeNum = `S${video.custom_fields.series}-E${video.custom_fields.episode}`
  } else if (video.custom_fields.series) {
    seriesAndEpisodeNum = `S${video.custom_fields.series}`
  } else if (video.custom_fields.episode) {
    seriesAndEpisodeNum = `E${video.custom_fields.episode}`
  }


  if (seriesAndEpisodeNum){ 
    if (!titleVal) {
      titleVal = seriesAndEpisodeNum
    } else {
      titleVal = titleVal + ` ${seriesAndEpisodeNum}`
    }
  }
  return titleVal || ""
}